import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAP_MODULE_NAMES, MAP_COMPONENT_NAMES, MAP_BUILD_NAMES } from 'src/models/common/EnumMapas';
import { MapConfiguration } from 'src/models/MapConfiguration';
import { InfoBoxMapService } from 'src/services/maps/features/InfoBox-Map.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { CallBackService } from '../../../callback/services/CallBack.service';
import { LayerService } from '../../../../map-features/sections/locations-section/services/Layers.service';
import { PanelExternalLayerService } from '../../../../map-features/sections/locations-section/services/Panel-External-Layer.service';
import { ToolCarsSelectorService } from '../../services/Tool-Cars-Selector.service';
import { RouteFilterService } from '../../../../map-features/sections/route-section/services/Route-Filter.service';
import { NavHeaderService } from '../../../../ui/organisms/header/service/nav-header.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { BaseMapService } from '../../services/BaseMap.service';
import { FULL_TOOLS_ALLOWED, ToolsEnum } from '../../utils/enums/toolsEnum';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { AllowedDTO } from '../../utils/models/allowedDTO';
import { PotentialZonesMapSectionService } from 'src/app/features/map-features/sections/potential-zones-section/services/potentialZones-map-section.service';
import { FULLY_ALLOWED_DETAILS_PANEL } from '../../utils/enums/detailsPanelAllowanceEnum';
import { MapRestrictionsService } from '../../services/MapRestrictions.service';
import { RouteSheetUtilService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheetUtil.service';

@Component({
  selector: 'app-unified-zones-map',
  templateUrl: './unified-zones-map.component.html',
  styleUrls: ['./unified-zones-map.component.css']
})
export class UnifiedZonesMapComponent {

  allowedParts: AllowedDTO = { 
      allowedTools: FULL_TOOLS_ALLOWED,
      allowedCategories: [],
      allowedFeaturesDetailsPanel: FULLY_ALLOWED_DETAILS_PANEL
    };
  
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
  carouselViewContainerRef!: ViewContainerRef;
    
  selectedPanel: any;

  //Variables para tooltip
  intersectMsg: string = "Selecciona varios puntos en el mapa para crear la SELECCIÓN DE UNIDADES. Para finalizar da click derecho sobre el mapa.";
  
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  MAP_BUILD_NAMES: any = MAP_BUILD_NAMES;
  
  constructor(
    private baseMapService: BaseMapService,
    private mapHelperService: MapHelperService,
    private locationsMapService: LocationsMapService,
    private routeSheetUtilService: RouteSheetUtilService,
    private navHeaderService: NavHeaderService,
    private panelExternalLayerService: PanelExternalLayerService,
    private callbackService: CallBackService,
    public infoBoxMapService: InfoBoxMapService,
    private routeFilterService: RouteFilterService,
    public toolCarSelectorService: ToolCarsSelectorService,
    public potentialZonesMapService: PotentialZonesMapSectionService,
    public localStorageService: LocalStorageService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    public layerService: LayerService,
    private mapRestrictionsService: MapRestrictionsService
    ){
      this.mobileQuery = media.matchMedia("(min-width: 761px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);      
  }
    
  ngOnInit(){
    this.InitialiceMapComponents();
    this.checkAllowedCategories();
    this.mapRestrictionsService.allowedParts$.next(this.allowedParts);
  }
  
  ngAfterViewInit(): void {
    this.navHeaderService.setIsPotentialZonesSelected(false);
    this.navHeaderService.CheckMapPaneles("locationsMap");
  }
  
  // ngOnDestroy(): void {
  //   this.panelExternalLayerService.capas = [];
  //   this.callbackService.isNeededCallback();
  //   this.mapHelperService.removeMap(MAP_BUILD_NAMES.Unilever);
  // }
  
  onToolTipVisibilityChange(isVisible: boolean) {
    this.toolCarSelectorService.isCarSelectionToolTipVisible = isVisible;
  }

  InitialiceMapComponents(){
    this.locationsMapService.setCarouselViewContainerRef(this.carouselViewContainerRef);
    this.routeSheetUtilService.setCarouselViewContainerRef(this.carouselViewContainerRef);
  }

  checkAllowedCategories(){
    const params = JSON.parse(localStorage.getItem("queryParams") || "{}");
    this.allowedParts.allowedCategories = params['idCategories'] ? params['idCategories'].split(',') : [];

    if(this.allowedParts.allowedCategories.length === 0){
      const categories = JSON.parse(this.localStorageService.getListaCategorias() || "[]");
      this.allowedParts.allowedCategories = categories.map((cat: any) => cat.id.toString());
      this.allowedParts.allowedCategories.push("gps");
    }
  }

}
